import { useCallback } from 'react'
import { useSearchParams } from 'react-router-dom'

import type { IntentFilter } from './conversations-model'
import {
  intentFilterFromRequestTypeQuery,
  requestTypeQueryFromIntentFilter,
} from './conversation-filters'

export function useConversationFilterRoute() {
  const [searchParams, setSearchParams] = useSearchParams()
  const intentFilter = intentFilterFromRequestTypeQuery(
    searchParams.get('requestType')
  )
  const setIntentFilter = useCallback(
    (filter: IntentFilter) => {
      setSearchParams((current) => {
        const next = new URLSearchParams(current)
        const requestType = requestTypeQueryFromIntentFilter(filter)
        if (requestType) next.set('requestType', requestType)
        else next.delete('requestType')
        return next
      })
    },
    [setSearchParams]
  )

  return { searchParams, intentFilter, setIntentFilter }
}
